import React from "react";

const RecentActivities = () => {
  return <div>RecentActivities</div>;
};

export default RecentActivities;
